import type { Module } from 'vuex';
import { Action } from '@/types/Action';
import {RootState} from "@/store";

export interface ActionsState {
  actions: Action[];
}

const actionsModule: Module<ActionsState, RootState> = {
  namespaced: true,

  state: (): ActionsState => ({
    actions: [],
  }),

  getters: {
    getById: (state) => (idAction: number): Action | undefined => {
      return state.actions.find(action => action.idAction === idAction);
    },
  },

  mutations: {
    setActions(
      state,
      payload: { actions: Record<number, any> }
    ) {
      state.actions = Object
        .values(payload.actions)
        .map(raw => Action.fromRaw(raw));
    },

    setActionCreate(
      state,
      payload: {
        idAction: number;
        name: string;
      }
    ) {
      const action = new Action(
        payload.idAction,
        payload.name,
        false,
      );
      state.actions.push(action);
    },

    setActionDelete(
      state,
      payload: { idAction: number }
    ) {
      state.actions = state.actions.filter(
        action => action.idAction !== payload.idAction
      );
    },
  },

  actions: {
    wsSetActions({ commit }, payload) {
      commit('setActions', payload);
    },
    wsActionCreate({ commit }, payload) {
      commit('setActionCreate', payload);
    },
    wsActionDelete({ commit }, payload) {
      commit('setActionDelete', payload);
    },
  },
};

export default actionsModule;
